import React  from 'react';
import CatalogTableC from '../../components/Catalogs/CatalogTableC';
import { UseFirmList } from '../../hooks/Catalogs/useFirm';
import PaginatedTable from '../../components/Organismos/Table/PaginatedTable';
import useDataLoader2 from '../../hooks/useDataLoader2';
import Eye2 from '../../components/Atomos/Icons/Eye';
import { defaultPageSize } from '../../utils/const';
import PersistentLink from '../../components/Moleculas/PersistentLink';
import Filters, { IFilterData } from '../../components/Catalogs/Filters/Filters';
import IOfficeContact from '../../interfaces/models/IOfficeContact';
import { exportAllDataLoader2 } from "../../utils/exportAllDataLoader2";

const OfficeContact: React.FC = () => {
  const fields = [
    'id', 
    'legacyId',
    'firm',
    'offices',
    'totalContacts',
    'firmName',
    'createdAt'
  ]
  const endpoint = '/officeContact';
  const { 
    data, 
    totalCount, 
    fetchData, 
    setFilter, 
    sort, 
    setSort, 
    pagination, 
    setPagination,
    filter,
    inputFilters,
    setInputFilters
  } = useDataLoader2<any>({
    endpoint,
    defaultPageSize,
    fields,
    defaultSorting: { field: "firm", order: "asc" },
  });
  const { firmData} = UseFirmList();

  const columnsDef = React.useMemo(() => [
    { 
      id: 'count', 
      header: '#', 
      enableSorting: false,
      cell: ({ rowIndex }: { rowIndex: number; row: any; value: any }) => (
        <p>{rowIndex + 1 + pagination.pageIndex * pagination.pageSize}</p>
      )
    },
    { id: 'firm', header: 'Firm' },
    { id: 'totalContacts', header: 'Total Contacts' },
    { id: 'createdAt', header: "Created Date" },
    {
      id: 'view', 
      header: 'View', 
      enableSorting: false,
      cell: ({ row }: { rowIndex: number; row: any; value: any }) => (
        <PersistentLink
          className="view"
          to={`View/${row.id}`}
          state={row}
          persistingData={{
            pagination,
            sort,
            filter, 
            inputFilters, 
          }}
        >
          <div className="editsvg flex gap-1"><span>View</span><Eye2 className="flex"/></div>
        </PersistentLink>
      )
    },
  ], [pagination.pageIndex, pagination.pageSize, sort, filter, inputFilters]);

  const formatData = (data: IOfficeContact[]) => {
    const formatedData = data.map(d => {
      return {
        ...d,
        firm: d.firmName,
        firmId: d.firm,
      }
    })
    return formatedData
  }

  const filtersData: IFilterData[] = React.useMemo(() => [
    {
      name: "Firm",
      objectData: firmData?.map((f: any) => ({id:f.id, name: f.name})) || [],
    },
  ], [firmData]);

  return (
    <>
        <CatalogTableC
          title={`Member Main Contacts Catalog`} catalogName={'MEMBER MAIN CONTACTS'} route={'OfficeContact'}
          totalCount={totalCount}
          noNewCatalog
        >
          <Filters
            filtersData={filtersData} 
            filterValues={inputFilters}
            setFilterValues={setInputFilters} 
            Search={() => fetchData()}
            clearSelections={() => fetchData(true)}
            setValueForQuery={setFilter}
          />
          <PaginatedTable
            data={data || []}
            columnsDef={columnsDef}
            formatData={formatData}
            sorting={sort}
            onSortingChange={setSort}
            totalCount={totalCount || 0}
            pagination={pagination}
            onPaginationChange={setPagination}
            endpoint={endpoint}
            onExportAll={() =>
              exportAllDataLoader2<any>({
                endpoint,
                filter,
                sort,
                pageSize: 1000,
                fields,
              })
            }
          />
        </CatalogTableC>
    </>
  );
};

export default OfficeContact;